import { apiFetcher } from '@gjensidige/service-async';
import { remoteLogFetchError } from '@gjensidige/service-error-handler';

export const fetchCallRequest = async (body: {
  errand: string;
  phoneNumber: string;
  entrance: string;
  menuchoice: string;
  comment: string;
  customerName: string;
}) => {
  const url = '/api-kundeservice/open/callguide/v2/callback';
  const response = await apiFetcher.postJson(url, {
    body
  });

  if (response.isErr()) {
    if (response.error.statusCode === 201) {
      return {
        success: true,
        code: '0'
      };
    } else {
      remoteLogFetchError(url, response.error, {
        extras: [
          {
            key: 'code',
            value: response.error.code
          }
        ]
      });
      return {
        success: false,
        code: response.error.code
      };
    }
  } else {
    return {
      success: true,
      code: '0'
    };
  }
};

interface AuthLevel {
  value: number;
}
export const getUserAuthLevel = async () => {
  const CUSTOMER_URL = '/api-tools/v1/open/auth-level';
  const response = await apiFetcher.getJson<AuthLevel>(CUSTOMER_URL);
  if (response.isOk()) {
    return response.value;
  } else {
    remoteLogFetchError(CUSTOMER_URL, response.error);
    return false;
  }
};
